// extracted by mini-css-extract-plugin
export default {"root":"ExclusionRuleRow_root__ex8We","placeholderSelect":"ExclusionRuleRow_placeholderSelect__ZHuQW"};